
import {getHistoryBonusGetById} from '../api/getHistoryBonusGetById';
import {setGetHistoryBonusGetByIdAction} from '../action';

const setGetHistoryBonusGetById = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getHistoryBonusGetById(params);

            if (data.status === 'success') {
                dispatch(setGetHistoryBonusGetByIdAction({
                    data: data.data,
                    count: data.count
                }));           
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetHistoryBonusGetById
}